import {
	Action,
	AnyAction,
	ThunkAction,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit';

import adsSlice from './slices/adsSlice';
import auctionSlice from './slices/auctionSlice';
import myBusinessSlice from './slices/myBusinessSlice';
import shakeReducer from './slices/shakeSlice';
import tabletSlice from './slices/tabletSlice';
import truckJobSlice from './slices/truckJobSlice';

const reducers = {
	tablet: tabletSlice,
	ads: adsSlice,
	shake: shakeReducer,
	auction: auctionSlice,
	myBusiness: myBusinessSlice,
	truckJob: truckJobSlice,
};

const rootReducer = combineReducers(reducers);

const combinedRootReducer = (
	state: ReturnType<typeof rootReducer> | undefined,
	action: AnyAction,
) => {
	if (action.type === 'resetStore') {
		return rootReducer(undefined, action);
	}
	return rootReducer(state, action);
};

export const store = configureStore({
	reducer: combinedRootReducer,
	devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
